import React, { useState } from "react";
import "./style.css";
import API from "../../utils/API";

const timeTables = [
  "ASAP",
  "Already licensed",
  "Within 3 months",
  "In 3-6 months",
  "In 6-12 months",
  "Next year",
  "Unsure",
  "Not Applicable"
];

function CreateReferringAgent({ source }) {
  const [formData, setFormData] = useState({
    agentFirstName: "",
    agentLastName: "",
    agentEmail: "",
    agentTelephone: "",
    licensingInterest: false,
    timeTableChosen: ""
  });

  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const submitForm = (e) => {
    e.preventDefault();

    console.log("Enrolled!");
    console.log(formData);

    const enrollmentData = {
      firstName: formData.agentFirstName,
      lastName: formData.agentLastName,
      email: formData.agentEmail,
      telephone: formData.agentTelephone,
      licensingInterest: formData.licensingInterest.toString(),
      timeTable: formData.timeTableChosen,
      source: source
    };

    API.saveEnrollmentData({
      firstName: enrollmentData.firstName,
      lastName: enrollmentData.lastName,
      email: enrollmentData.email,
      telephone: enrollmentData.telephone,
      licensingInterest: enrollmentData.licensingInterest,
      timeTable: enrollmentData.timeTable,
      source: enrollmentData.source
    })
      .then((_res) => {
        console.log("Saved Enrollment!");
        alert("Enrollment Successful, we'll be in touch!");
      })
      .catch((err) => {
        console.log(err);
        alert("Something went wrong, please try again!");
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-lg-2"></div>
        <div className="col-lg-8">
          <div
            className="card"
            style={{ backgroundColor: "black", color: "white", fontWeight: "bold" }}
          >
            <div className="card-header" style={{ textAlign: "center" }}>
              <img
                className="boxshadow"
                style={{ borderRadius: "10px", width: "50%", height: "20%" }}
                src="/images/fawn-logo.png"
                alt="fawnlogo"
              ></img>
            </div>
            <div
              className="card-body"
              style={{ textAlign: "center", backgroundColor: "white", color: "black" }}
            >
              <form>
                <div className="row">
                  <div className="col-lg-6">
                    <label>First Name</label>
                    <br />
                    <input
                      type="text"
                      value={formData.agentFirstName}
                      onChange={handleInputChange}
                      name="agentFirstName"
                      placeholder="Jack"
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>Last Name</label>
                    <br />
                    <input
                      type="text"
                      value={formData.agentLastName}
                      onChange={handleInputChange}
                      name="agentLastName"
                      placeholder="Black"
                    />
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-lg-6">
                    <label>Email</label>
                    <br />
                    <input
                      type="text"
                      value={formData.agentEmail}
                      onChange={handleInputChange}
                      name="agentEmail"
                      placeholder="@"
                    />
                  </div>

                  <div className="col-lg-6">
                    <label>Phone</label>
                    <br />
                    <input
                      type="text"
                      value={formData.agentTelephone}
                      onChange={handleInputChange}
                      name="agentTelephone"
                      placeholder="#"
                    />
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-lg-12">
                    <label>Would you like to get licensed, or are you already licensed?</label>
                    <br />
                    <input
                      type="checkbox"
                      checked={formData.licensingInterest}
                      onChange={handleInputChange}
                      name="licensingInterest"
                    />
                  </div>
                  {formData.licensingInterest === true ? (
                    <div className="row">
                      <div className="col-lg-12">
                        <label>When would you like to get licensed?</label>
                        <br />
                        <select
                          id="licensingTimeTable"
                          value={formData.timeTableChosen}
                          onChange={handleInputChange}
                          name="timeTableChosen"
                        >
                          <option value=""></option>
                          {timeTables.map((time) => (
                            <option key={time} value={time}>
                              {time}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  ) : null}
                </div>
                <br />
                <div className="row">
                  <div className="col-lg-4"></div>
                  <div className="col-lg-4" style={{ textAlign: "center" }}>
                    <button className="btn-success btn-sm btn" onClick={submitForm}>
                      Enroll
                    </button>
                  </div>
                  <div className="col-lg-4"></div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-lg-2"></div>
      </div>
    </div>
  );
}

export default CreateReferringAgent;
